import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/campaign/$shortId")({
  component: () => <Outlet />,
});
